$(document).foundation()

jQuery(document).ready(function($) {

  var personIndex = 0
  var $body = $('body')
  var megaMenuIndex = 0
  // header - toggle search
  $('.toggle-search').on('click', function(e) {
    if ($('body').hasClass('header--search-is-open')) {
      closeSearch()
    } else {
      openSearch()
    }
    e.preventDefault()
  }).keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click')
      e.preventDefault()
    }
  })

  // body - escape - close everything
  $('body').on('keyup', function(e) {
    if (e.key == 'Escape') {
      closeSearch()
      closeMegaMenu()
      closeMobileMenu()
    }
  })

  // header - open search
  function openSearch() {
    $('body').addClass('header--search-is-open')
    // accessibility
    $('.search-bar').attr('tabindex', 0).focus()
    $('.search-bar input[type="text"]').focus()
  }

  // header - close earch
  function closeSearch() {
    $('body').removeClass('header--search-is-open')
    // accessibility
    $('.search-bar').attr('tabindex', -1)
  }

  // header - toggle megamenu
  function openMegaMenu() {
    var bgColors = ['#F17DB1', '#6DCDE3', '#008663', '#FBAB20']
    var windowHeight = $(window).height()
    var bottomLogoY = windowHeight - 98
    gsap.to('.notification-bar', { height: 0 })
    gsap.to('.mega-menus', { height: '100%', backgroundColor: bgColors[megaMenuIndex] } )
    gsap.to('.mega-menu', { autoAlpha: 0, display: 'none', duration: 0.1 })
    gsap.to('.mega-menu-' + megaMenuIndex, { autoAlpha: 1, display: 'block' })
    gsap.to('.logo-bottom', { y: bottomLogoY })
    gsap.to('.logo-line', { height: windowHeight })
    gsap.fromTo('.mega-menu-' + megaMenuIndex + ' li', {
      duration: 1,
      x: -60,
      ease: 'power2.inOut',
      opacity: 0,
      stagger: 0.15,
    }, {
      duration: 1,
      x: 0,
      ease: 'power2.inOut',
      opacity: 1,
      stagger: 0.15,
    });
    // accessibility
    $('.mega-menu').attr('tabindex', -1)
    $('.mega-menu-' + megaMenuIndex).attr('tabindex', 0).focus()
  }

  function closeMegaMenu() {
    var tlMegaMenu = gsap.timeline()
    tlMegaMenu.to('.mega-menu', { autoAlpha: 0, display: 'none' }, 0)
    tlMegaMenu.to('.logo-line', { height: 0 }, 0)
    tlMegaMenu.to('.logo-bottom', { y: 0 }, 0)
    tlMegaMenu.to('.mega-menus', { height: 0 }, 0)
    tlMegaMenu.to('.notification-bar', { height: 'auto' }, 0)
    setTimeout(function() {
      $('body').removeClass('header--mega-menu-is-open')
    }, 500)
    // accessibility
    $('.mega-menu').attr('tabindex', -1)
  }

  $('.main-menu li:not(.toggles) a').on('click', function(e) {
    e.preventDefault()
    var $a = $(this)
    megaMenuIndex = $a.parent().index()
    openMegaMenu()
    closeSearch()
    $('body').addClass('header--mega-menu-is-open')
  }).keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click')
      e.preventDefault()
    }
  })

  $('.close-mega-menu').on('click', function(e) {
    closeMegaMenu()
    e.preventDefault()
  })

  function openMobileMenu() {
    gsap.to('.notification-bar', { height: 0 })
    gsap.to('.mobile-menu', { height: '100%' } )
    gsap.fromTo('.mobile-menu li, .mobile-menu .bottom .grid-x', {
      duration: 1,
      x: -30,
      ease: 'power2.inOut',
      opacity: 0,
      stagger: 0.15,
    }, {
      duration: 1,
      x: 0,
      ease: 'power2.inOut',
      opacity: 1,
      stagger: 0.15,
    });
    //console.log('openMobileMenu')
  }

  function closeMobileMenu() {
    gsap.to('.notification-bar', { height: 'auto' })
    gsap.to('.mobile-menu', { height: 0 } )
    setTimeout(function() {
      $('body').removeClass('header--mobile-menu-is-open')
    }, 500)
  }


  $('.open-mobile-menu').on('click', function(e) {
    $('body').addClass('header--mobile-menu-is-open')
    closeSearch()
    openMobileMenu()
    e.preventDefault()
  })

  $('.close-mobile-menu').on('click', function(e) {
    closeMobileMenu()
    e.preventDefault()
  })

  $('.mobile-menu .accordion-title').on('click', function() {
    var bgColors = ['#F17DB1', '#6DCDE3', '#008663', '#FBAB20']
    var index = $(this).parent().index()
    gsap.to('.mobile-menu', { backgroundColor: bgColors[index] } )
  })

  // submenu toggler
  $('.tab-submenu .submenu-toggler, .submenu .submenu-toggler').on('click', function() {
    $(this).parent().toggleClass('submenu--is-open')
  })

  $('.block-slideshow-box, .block-homepage-hero-slideshow').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel-images').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 3500,
      on: {
        select: function() {
          if ($carousel) {
            var currentIndex = $carousel.data('flickity').selectedIndex
            if ($carouselDescriptions) {
              $carouselDescriptions.flickity('select', currentIndex)
            }
            $block.find('.dot').removeClass('is-active').eq(currentIndex).addClass('is-active')
            // accessibility
            $carousel.find('.carousel-cell, .carousel-cell a').attr('tabIndex', -1).attr('disabled', true)
            $carousel.find('.carousel-cell.is-selected, .carousel-cell.is-selected a').attr('tabIndex', 0).removeAttr('disabled')
          }
        }
      }
    })

    var $carouselDescriptions = $block.find('.carousel-descriptions').flickity({
      cellSelector: '.carousel-cell',
      draggable: false,
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carouselDescriptions) {
            // accessibility
            $carouselDescriptions.find('.carousel-cell, .carousel-cell a').attr('tabIndex', -1).attr('disabled', true)
            $carouselDescriptions.find('.carousel-cell.is-selected, .carousel-cell.is-selected a').attr('tabIndex', 0).removeAttr('disabled')
          }
        }
      }
    })

    $block.find('.dot').on('click', function(e) {
      $carousel.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carousel.flickity('pausePlayer');
      $carousel.flickity('previous')
      setTimeout(() => {
        $carousel.flickity('unpausePlayer');
      }, 500);
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carousel.flickity('pausePlayer');
      $carousel.flickity('next')
      setTimeout(() => {
        $carousel.flickity('unpausePlayer');
      }, 500);
      e.preventDefault()
    })

  })

  $('.block-slideshow').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 3500,
      on: {
        select: function() {
          if ($carousel) {
            // accessibility
            $carousel.find('.carousel-cell, .carousel-cell a').attr('tabIndex', -1).attr('disabled', true)
            $carousel.find('.carousel-cell.is-selected, .carousel-cell.is-selected a').attr('tabIndex', 0).removeAttr('disabled')
          }
        }
      }
    })
  })

  $('.block-image-slideshow').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 3500,
      on: {
        select: function() {
          if ($carousel) {
            // accessibility
            $carousel.find('.carousel-cell, .carousel-cell a').attr('tabIndex', -1).attr('disabled', true)
            $carousel.find('.carousel-cell.is-selected, .carousel-cell.is-selected a').attr('tabIndex', 0).removeAttr('disabled')
          }
        }
      }
    })
  })

  $('.block-cards-carousel').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carousel) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carousel.data('flickity').selectedIndex).addClass('is-selected')
          }
        }
      }
    })

    $block.find('.flickity-page-dots-custom li').on('click', function(e) {
      $carousel.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carousel.flickity('previous')
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carousel.flickity('next')
      e.preventDefault()
    })
  })

  $('.block-gallery-images-videos').each(function() {
    var $block = $(this)

    var $carouselLarge = $block.find('.carousel-large').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      draggable: Foundation.MediaQuery.current == 'small',
      on: {
        select: function() {
          if ($carouselLarge) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carouselLarge.data('flickity').selectedIndex).addClass('is-selected')
          }
        }
      }
    })

    var $carouselSmall = $block.find('.carousel-small').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carouselSmall) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carouselSmall.data('flickity').selectedIndex).addClass('is-selected')
            if ($carouselLarge) {
              $carouselLarge.flickity('select', $carouselSmall.data('flickity').selectedIndex)
            }
          }
        }
      }
    })

    $carouselSmall.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
      $carouselSmall.flickity('select', cellIndex)
    });

    $block.find('.flickity-page-dots-custom li').on('click', function(e) {
      $carouselSmall.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carouselSmall.flickity('previous')
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carouselSmall.flickity('next')
      e.preventDefault()
    })
  })

  $('.block-press-carousel').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel-press').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carousel) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carousel.data('flickity').selectedIndex).addClass('is-selected')
          }
        }
      }
    })

    $block.find('.flickity-page-dots-custom li').on('click', function(e) {
      $carousel.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carousel.flickity('previous')
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carousel.flickity('next')
      e.preventDefault()
    })
  })

  $('.block-signature-events-carousel').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel-signature-events').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carousel) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carousel.data('flickity').selectedIndex).addClass('is-selected')
          }
        }
      }
    })

    $block.find('.flickity-page-dots-custom li').on('click', function(e) {
      $carousel.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carousel.flickity('previous')
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carousel.flickity('next')
      e.preventDefault()
    })
  })

  $('.block-information-carousel').each(function() {
    var $block = $(this)
    var $carousel = $block.find('.carousel').flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: 0,
      on: {
        select: function() {
          if ($carousel) {
            $block.find('.flickity-page-dots-custom li').removeClass('is-selected').eq($carousel.data('flickity').selectedIndex).addClass('is-selected')
          }
        }
      }
    })

    $block.find('.flickity-page-dots-custom li').on('click', function(e) {
      $carousel.flickity('select', $(this).index())
      e.preventDefault()
    })

    $block.find('.previous').on('click', function(e) {
      $carousel.flickity('previous')
      e.preventDefault()
    })

    $block.find('.next').on('click', function(e) {
      $carousel.flickity('next')
      e.preventDefault()
    })
  })

  // block grid people
  $('.block-grid-people a').on('click', function() {
    personIndex = $(this).closest('.cell').index()
  })

// block grid people
  $('.block-contact-info .staff-extension a').on('click', function() {
    personIndex = $(this).data('person-index')
  })

  // guide links
  $('.block-walking-tours-info-guides .guides a').on('click', function() {
    personIndex = $(this).closest('.cell').index()
  })

  $('.block-reports-data .pdf-links .more').on('click', function(e) {
    var $pdfLinks = $(this).closest('.pdf-links')
    $pdfLinks.find('p.hide').removeClass('hide')
    $(this).remove()
    e.preventDefault()
  })

  // before after
  $('.block-before-after').each(function() {
    var $block = $(this)
    const viewers = document.querySelectorAll(".image-compare");
  
    viewers.forEach((element) => {
      var beforeImage = element.querySelector('.before')
      var afterImage = element.querySelector('.after')
      var beforeLabel = beforeImage.getAttribute('data-label')
      var afterLabel = afterImage.getAttribute('data-label')
      var options = {}

      if (beforeLabel || afterLabel) {
        options = {
          showLabels: true,
          labelOptions: {
            before: beforeLabel,
            after: afterLabel,
            onHover: false
          }
        }
      }

      options.controlShadow = false;

      new ImageCompare(element, options).mount();
    });
  })

  // Grid of images gallery
  $('.grid-image-gallery').each(function () {
    var $item = $(this)
    var gallery = $item.data('gallery')
    $item.magnificPopup({
      items: gallery,
      gallery: {
        enabled: true,
      },
      type: 'image',
    })
  })

  // form for filters
  $('.block-with-filters').each(function() {
    var $block = $(this)
    var $form = $block.find('form.form-filters')

    $form.find('.tag').on('click', function(e) {
      var $tag = $(this)
      var tid = $tag.data('term-id')
      var tids = []
      $form.find('input[type="checkbox"]').prop('checked', false)
      if (tid == 0) {
        $form.find('.tag').removeClass('is-selected')
        $form.find('.tag[data-term-id="0"]').addClass('is-selected')
      } else {
        $tag.toggleClass('is-selected')
        $form.find('.tag').each(function() {
          var $tag = $(this)
          var tid = $tag.data('term-id')
          if ($tag.hasClass('is-selected') && tid > 0) {
            $form.find('input[type="checkbox"][value="' + tid + '"]').prop('checked', true)
            tids.push(tid)
          }
        })
      }
      if (tids.length == 0) {
        $form.find('.tag[data-term-id="0"]').addClass('is-selected')
      } else {
        $form.find('.tag[data-term-id="0"]').removeClass('is-selected')
      }

      refreshFiltersResults()

      e.preventDefault()
    })

    // on submit
    $form.on('submit', function() {
      refreshFiltersResults()
      return false
    })

    // date ranger
    var flatpickrOptions = {
      mode: 'range',
      minDate: 'today',
      dateFormat: 'm/d/Y',
      onChange: function(selectedDates, dateStr, instance) {
        //instance.element.value = dateStr.replace('to', '-')
      },
      onClose: function(selectedDates, dateStr, instance) {
        refreshFiltersResults()
      }
    }
    $('.filter-date-range').flatpickr(flatpickrOptions)

    // call to refresh results
    function refreshFiltersResults() {
      var url = ''
      var params = []
      $form.find('input[type="checkbox"]').each(function() {
        var $checkbox = $(this)
        if ($checkbox.is(':checked')) {
          params.push('tids[]=' + $checkbox.val())
        }
      })
      if ($form.find('input[name="filter-keyword"]').val()) {
        params.push('filter-keyword=' + $form.find('input[name="filter-keyword"]').val())
      }
      if ($form.find('input[name="date-range"]').val()) {
        params.push('date-range=' + $form.find('input[name="date-range"]').val())
      }
      if (params.length > 0) {
        url = '?'
        url += params.join('&')
      }
      url = window.location.pathname + url
      history.pushState(null, null, url)
      //console.log(url)

      $.ajax({
        url: url,
        cache: true,
        dataType: 'html',
        beforeSend: function(xhr) {
          $block.find('.results').empty().addClass('results--is-loading')
        }
      }).done(function(html) {
        $block.find('.results').removeClass('results--is-loading')
        var resultsHtml = $(html).filter('.page').find('.results').html()
        $block.find('.results').html(resultsHtml)
      }).fail(function(error) {
        alert('Error loading ' + href)
      })
    }

  })

  // view more action
  $(document).on('click', '.block-pagination .view-more', function(e) {
    var $block = $(this).closest('.block-pagination')
    var $viewMore = $block.find('.view-more')
    var pageSize = parseInt($viewMore.data('page-size'))
    $block.find('.pagination-item.hide').slice(0, pageSize).removeClass('hide')
    if ($block.find('.pagination-item.hide').length == 0) {
      $viewMore.remove()
    }
    e.preventDefault()
  })

  // contact map
  if ($('#contact-map').length > 0) {

    function initContactMap() {
      var map = new google.maps.Map(document.getElementById("contact-map"), {
        zoom: 17,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControl: true,
        fullscreenControl: false,
        center: { lat: 40.743170, lng: -73.990850 },
      })

      // set style
      var mapType = new google.maps.StyledMapType([ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ])
      map.mapTypes.set('snazzyMapType', mapType)
      map.setMapTypeId('snazzyMapType')

      // add marker
      map.markers = [];
      var latlng = new google.maps.LatLng( 40.743170, -73.990850 );
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: {
          url: '/wp-content/themes/flatirondistrict/assets/img/map-marker-services.png',
          scaledSize: new window.google.maps.Size(30, 30)
        }
      });
      map.markers.push(marker);
      google.maps.event.addListener(marker, 'click', function() {
        window.open('https://maps.google.com/maps/dir/27+W+24th+St+%23800b+New+York,+NY+10010+USA/@40.7431637,-73.9908129,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x89c259a4415ae31f:0xeb638b2d90c3fb46')
      });
    }
    initContactMap()
  }

  // subscribe form
  $('form.subscribe-form').on('submit', function() {
    var email = $(this).find('input[type="email"]').val()
    $('#input_2_5').val(email)
    $('#newsletter-signup-modal').foundation('open')
    return false
  })

  if (window.location.hash == "#newsletter") {
    $('#newsletter-signup-modal').foundation('open')
  }

  // reveal carousel of people
  $('.reveal-people').each(function() {
    var $reveal = $(this)
    var $carousel = $reveal.find('.carousel-people').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
      pauseOnHover: false,
      autoPlay: false,
      on: {
        select: function() {
          if ($carousel) {
            // accessibility
            $carousel.find('.carousel-cell, .carousel-cell a').attr('tabIndex', -1).attr('disabled', true)
            $carousel.find('.carousel-cell.is-selected, .carousel-cell.is-selected a').attr('tabIndex', 0).removeAttr('disabled')
          }
        }
      }
    })
    $reveal.find('.previous').on('click', function() {
      $carousel.flickity('previous')
    })

    $reveal.find('.next').on('click', function() {
      $carousel.flickity('next')
    })
  })

  $(document).on('open.zf.reveal', '[data-reveal]', function () {
    $('.carousel-people').flickity('resize').flickity('select', personIndex)
  })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

  // block instagram
  $('.block-instagram-feed').each(function() {
    var $block = $(this)
    // accessibility - remove role='carousel'
    setTimeout(function() {
      $block.find('#sbi_images').removeAttr('role')
      $block.find('#sbi_images a.sbi_photo').attr('aria-label', 'View on Instagram')
    }, 3000)
  })

  // Block video overlay
  var $blockVideoOverlay = $('.block-video-overlay')

  function fadeOutBlockVideoOverlay(speed, delay) {
    var $videoOverlay = $blockVideoOverlay.find('video:visible, button')
    $videoOverlay.fadeTo(speed, 0, function() {
      $blockVideoOverlay.delay(delay).fadeTo(speed, 0, function() {
        $('html').removeClass('block-video-overlay--enabled');
        $blockVideoOverlay.remove();
        $(window).trigger('openingVideoClosed');
      });
    })
  }

  if ($blockVideoOverlay.length > 0) {
    var cookieKey = $blockVideoOverlay.data('cookie-key')
    var cookie = window.Cookies.get(cookieKey)

    $blockVideoOverlay.find('video, button').on('click', function (e) {
      e.preventDefault();
      fadeOutBlockVideoOverlay(500, 250);
      window.Cookies.set(cookieKey, true);
    });

    setTimeout(() => {
      $(window).trigger('openingVideoStarted');
    }, 250)

    // Only show video when cookie is not exists
    if (!cookie) {
      $('html').addClass('block-video-overlay--enabled');
      $blockVideoOverlay.removeClass('hidden')
      var $videoOverlay = $blockVideoOverlay.find('video:visible')
      window.Cookies.set(cookieKey, true)

      $videoOverlay.get(0).play()
        .catch(function(error) {
          // On iOS when low power mode is active, the video can't be autoplayed
          // If this happened, just fadeout the video
          fadeOutBlockVideoOverlay(750, 250)
        })
  
      $videoOverlay.on('ended', function() {
        fadeOutBlockVideoOverlay(750, 250)
      })
    } else {
      fadeOutBlockVideoOverlay(0, 0)
    }
  }

  // Load portal status
  var $portalStatus = $('.portal-status')
  if ($portalStatus) {
    $.ajax({
      url: window.flatiron_config.ajaxurl,
      data: {
        action: 'fetch_portal_status'
      }
    })
    .done(function (res) {
      $portalStatus.html(res)
    })

    // Portal Hover
    $('body').on('mouseenter', '.portal-status', function() {
      $portalStatus.addClass('hovered')
    }).on('mouseleave', '.portal-status', function () {
      $portalStatus.removeClass('hovered')
    })
  }

  $(window).on('openingVideoStarted', function () {
    // When video opening opened, pause the slider and select the first slide
    const $slideshow = $('.block-homepage-hero-slideshow .carousel-images');
    if ($slideshow.length > 0) {
      $slideshow.flickity('pausePlayer');
      $slideshow.flickity('select', 0, false, true)
    }
  })

  $(window).on('openingVideoClosed', function () {
    // Set the slider to first slide when video opening closed
    setTimeout(function () {
      const $slideshow = $('.block-homepage-hero-slideshow .carousel-images');
      if ($slideshow.length > 0) {
        $slideshow.flickity('unpausePlayer')
      }
    }, 300)
  })

  // Newsletter popup
  var $newsletterPopup = $('.newsletter-popup')
  if ($newsletterPopup.length > 0) {
    var popupOpenTimeline = gsap.timeline({
      paused: true,
      onStart: function () {
        $newsletterPopup.show();
        $('html').addClass('popup-opened');
      },
    })
    popupOpenTimeline.fromTo('.newsletter-popup__overlay', {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 0.2,
    })
    popupOpenTimeline.fromTo('.newsletter-popup__block', {
      opacity: 0,
      y: 30,
    }, {
      opacity: 1,
      y: 0,
      duration: 0.4,
    }, '<')

    var popupCloseTimeline = gsap.timeline({
      paused: true,
      onComplete: function () {
        setTimeout(function () {
          $newsletterPopup.hide();
          $('html').removeClass('popup-opened');
          window.Cookies.set('newsletter-shown', true, { expires: 7 });
        }, 600)
      }
    })
    popupCloseTimeline.fromTo('.newsletter-popup__overlay', {
      opacity: 1,
    }, {
      opacity: 0,
      duration: 0.2,
    })
    popupCloseTimeline.fromTo('.newsletter-popup__block', {
      opacity: 1,
      y: 0,
    }, {
      opacity: 0,
      y: -30,
      duration: 0.4,
    }, '<')

    $('.newsletter-popup .close-button').on('click', function () {
      popupCloseTimeline.play()
    });

    $(window).on('openingVideoClosed', function () {
      setTimeout(function () {
        popupOpenTimeline.play()
      }, 300)
    })

    // Show directly when there is no video overlay
    if ($('.block-video-overlay').length == 0) {
      setTimeout(function () {
        popupOpenTimeline.play()
      }, 300)
    }

    // Listen to the gravity form event
    $(document).on('gform_confirmation_loaded', function (event, formId) {
      var $form = $('#gf_' + formId)
      if ($form) {
        var $popup_content = $form.closest('.newsletter-popup__content');
        if ($popup_content) {
          $popup_content.find('.should-hide-on-success').hide();
        }
      }
    });
  }
});

// Homepage Hero Logo Animation
(function ($) {

  var $body = $('body');
  var $window = $(window);
  var max_logo_width = 1400;
  var big_logo_ratio = 388.29/1400; // if the size of big logo changed, please change this variable too
  var $logo_container = $('header .logo-container');
  var $hero_slideshow = $('.block-homepage-hero-slideshow .carousels');
  var $slideshow_textbottom = $hero_slideshow.find('.text-bottom');
  var $big_logo = $('.big-logo');
  var $homepageHeroBoxes = $('.block-homepage-hero-slideshow .boxes')
  var big_logo_width;

  // Calculate logo size
  var calculateLogoSize = function() {
    var window_width = $window.width();
    var offset = $logo_container.offset();

    // We need to find the height of the big logo without getting the height directly from svg element
    // When scrolled, the height of big logo is changed, so we need to calculate from the ratio
    big_logo_width = window_width < max_logo_width ? window_width : max_logo_width;
    var big_logo_height = big_logo_width * big_logo_ratio;

    // Find the position where the big logo will be placed
    var hero_innerheight = $hero_slideshow.innerHeight();
    if ($slideshow_textbottom.length > 0) {
      hero_innerheight -= $slideshow_textbottom.innerHeight();
    }
    var hero_slide_offset = $hero_slideshow.offset().top + hero_innerheight;
    var big_logo_top_pos = hero_slide_offset - big_logo_height + 3; // 3px is extra offset

    $big_logo.css({
      top: big_logo_top_pos,
      left: offset.left,
    });

    $homepageHeroBoxes.css({
      left: offset.left,
    })
  };

  if ($hero_slideshow.length > 0) {
    $window.on('resize', _.debounce(calculateLogoSize, 250)).trigger('resize');
  }

  // header headroom and scrolltrigger
  var headroomOffset = 100;
  if ($hero_slideshow.length > 0) {
    // headroomOffset = $hero_slideshow.find('.carousel-images img').height() * 0.75;
    headroomOffset = $hero_slideshow.find('.carousel-images img').height() * 0.2;
  }

  var headerElement = document.getElementById('header');
  var headerHeadroom = new Headroom(headerElement, {
    offset: headroomOffset,
  })
  headerHeadroom.init();
  
  window.addEventListener('resize', _.debounce(function() {
    var newOffset = 100;
    if ($hero_slideshow.length > 0) {
      newOffset = $hero_slideshow.find('.carousel-images img').height() * 0.75;
    }

    headerHeadroom.destroy();
    headerHeadroom = new Headroom(headerElement, {
      offset: newOffset,
    });
    headerHeadroom.init();
  }, 250))

  // scrolltrigger on homepage hero slideshow
  // $window.on('load', function() {
  //   if ($hero_slideshow.length > 0) {
  //     var $header_logo = $('header#header .logo-top');
  
  //     gsap
  //       .timeline({
  //         scrollTrigger: {
  //           trigger: $hero_slideshow,
  //           start: function() {
  //             var start = $hero_slideshow.offset().top;
  //             return 'top ' + start;
  //           },
  //           end: function() {
  //             var end = $hero_slideshow.offset().top;
  //             return '75% ' + end;
  //           },
  //           scrub: true,
  //           // markers: true,
  //           invalidateOnRefresh: true
  //         },
  //       })
  //       .to('.big-logo', {
  //         // left: function() {
  //         //   var offset = $logo_container.offset();
  //         //   return offset.left;
  //         // },
  //         y: function() {
  //           var targetOffset = $logo_container.offset();
  //           var currentOffset = $big_logo.offset();
            
  //           return (currentOffset.top - targetOffset.top) * -1;
  //         },
  //         scale: function() {
  //           return $header_logo.width() / big_logo_width;
  //         },
  //       }, 0)
  //       .to('.logo-image polygon, .logo-image path, .logo-image rect', {
  //         fill: '#000000'
  //       }, 0)
  //       .to('.logo-image', { opacity: 0, duration: 0 }, '>');
  //   }
  // });

  // Toggle the weather visibility on header when scrolled up or down
  // use requestAnimationFrame for performance
  function toggleWeatherVisibility() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop > 0) {
      if (!$body.hasClass('weather-hidden')) {
        $body.addClass('weather-hidden');
      }
    } else {
      if ($body.hasClass('weather-hidden')) {
        $body.removeClass('weather-hidden');
      }
    }

    window.requestAnimationFrame(toggleWeatherVisibility);
  }

  window.requestAnimationFrame(toggleWeatherVisibility);
  toggleWeatherVisibility();

  // Member directory search form
  $('.block-member-directory__search select').on('change', (e) => {
    $('.block-member-directory__search form').get(0).submit();
  });

})(jQuery);

// Function to initialize the Google Places Autocomplete
function initializeGooglePlacesAutocomplete() {
    const addressField = document.querySelector('#input_13_7');
    // Check if the field exists and hasn't been initialized yet
    if (addressField && !addressField.hasAttribute('data-autocomplete-initialized')) {
        const autocomplete = new google.maps.places.Autocomplete(addressField, {
            types: ['address'],
            componentRestrictions: { country: 'us' }
        });
        addressField.setAttribute('data-autocomplete-initialized', 'true');

        autocomplete.addListener('place_changed', function() {
            const place = autocomplete.getPlace();
            // You can process place details here if needed
        });
    }
}

// Re-initialize autocomplete after Gravity Forms AJAX update
$(document).on('gform_post_render', function(event, form_id, current_page) {
    initializeGooglePlacesAutocomplete();
});

// paginating blocks
/*
$('.block-pagination').each(function() {

  var $block = $(this)
  var $pagination = $block.find('.pagination')
  var $paginationItems = $block.find('.pagination-item')
  var totalPages = parseInt($pagination.data('total-pages'))
  var pageSize = parseInt($pagination.data('page-size'))

  $pagination.find('a.number').on('click', function(e) {
    var $number = $(this)
    var page = parseInt($number.data('page'))
    $pagination.data('current-page', page)
    updatePagination()
    updatePaginationItems()
    e.preventDefault()
  })

  $pagination.find('a.previous').on('click', function(e) {
    var page = parseInt($pagination.data('current-page'))
    var nextPage = page - 1
    if (nextPage < 0) {
      nextPage = 0
    }
    $pagination.data('current-page', nextPage)
    updatePagination()
    updatePaginationItems()
    e.preventDefault()
  })

  $pagination.find('a.next').on('click', function(e) {
    var page = parseInt($pagination.data('current-page'))
    var nextPage = page + 1
    if (nextPage >= totalPages-1) {
      nextPage = totalPages-1
    }
    $pagination.data('current-page', nextPage)
    updatePagination()
    updatePaginationItems()
    e.preventDefault()
  })

  function updatePagination() {
    var page = parseInt($pagination.data('current-page'))
    $pagination.removeClass('previous-disabled next-disabled')
    $pagination.find('a.number').removeClass('is-selected')
    $pagination.find('a.number[data-page="' + page + '"]').addClass('is-selected')
    if (page == 0) {
      $pagination.addClass('previous-disabled')
    }
    if (page == totalPages-1) {
      $pagination.addClass('next-disabled')
    }
  }

  function updatePaginationItems() {
    var page = parseInt($pagination.data('current-page'))
    var scrollAmount = $block.offset().top - $(header).height() - 50
    $('html, body').animate({ scrollTop: scrollAmount }, 500, function() {
      var startIndex = page * pageSize
      var endIndex = startIndex + pageSize
      $paginationItems.addClass('hide').slice(startIndex, endIndex).removeClass('hide')
    })
  }
})
*/

$('.block-signature-events-menu').each(function() {
  var includeEmptySections = false // Set to false to ignore sections with empty data-jump-link-id
  
  var $block = $(this)
  var $menu = $block.find('.menu-list')
  var $menuToggle = $block.find('.menu-toggle')
  var headerHeightOffset = $(window).width() > 768 ? 130 : 100;
  var sections = []
  var allSections = []
  
  // Setup click handlers and collect section information
  $menu.find('a').each(function() {
    var $link = $(this)
    var href = $link.attr('href')
    var jumpLinkId = href.split('#')[1]
    if (jumpLinkId) {
      var $target = $('[data-jump-link-id="' + jumpLinkId + '"]')
      if ($target.length > 0) {
        sections.push({
          id: jumpLinkId,
          $element: $target,
          $menuItem: $link.parent('li')
        })
        
        $link.on('click', function(e) {
          e.preventDefault()

          if ($menu.hasClass('is-open')) {
            $menu.removeClass('is-open')
          }
          
          var targetOffset = 0;
          if ($target.hasClass('block-text')) {
            targetOffset = 30;
          }
          $('html, body').animate({
            scrollTop: $target.offset().top - headerHeightOffset - targetOffset
          }, 1000)

        })
      }
    } else {
      $link.on('click', function(e) {
        if ($menu.hasClass('is-open')) {
          $menu.removeClass('is-open')
        }
      });
    }
  })
  $menuToggle.on('click', function(e) {
    e.preventDefault()
    $menu.toggleClass('is-open')
  })
  // Collect all sections including those with empty data-jump-link-id (if includeEmptySections is true)
  if (includeEmptySections) {
    $('[data-jump-link-id]').each(function() {
      var $el = $(this)
      var id = $el.attr('data-jump-link-id')
      allSections.push({
        id: id,
        $element: $el,
        isEmpty: !id || id.trim() === ''
      })
    })
  } else {
    // Only include sections that have menu items
    allSections = sections.slice()
  }
  
  // Add scroll event handler to track active section
  if (sections.length > 0) {
    var updateActiveSection = function() {
      var scrollTop = $(window).scrollTop()
      
      // If at the top of the page, remove all active states
      if (scrollTop === 0) {
        sections.forEach(function(section) {
          section.$menuItem.removeClass('active')
        })
        return
      }
      
      var scrollPos = scrollTop + headerHeightOffset + 50 // Add extra offset for better UX
      var currentSection = null
      
      // Find the current section based on scroll position
      for (var i = allSections.length - 1; i >= 0; i--) {
        var section = allSections[i]
        if (section.$element.offset().top <= scrollPos) {
          currentSection = section
          break
        }
      }
      
      // Update active states
      if (includeEmptySections && currentSection && currentSection.isEmpty) {
        // If current section has empty data-jump-link-id, remove all active states
        sections.forEach(function(section) {
          section.$menuItem.removeClass('active')
        })
      } else if (currentSection) {
        // Find matching menu item and set it active
        var matchingSection = null
        for (var j = 0; j < sections.length; j++) {
          if (sections[j].id === currentSection.id) {
            matchingSection = sections[j]
            break
          }
        }
        
        sections.forEach(function(section) {
          section.$menuItem.removeClass('active')
        })
        
        if (matchingSection) {
          matchingSection.$menuItem.addClass('active')
        }
      }
    }
    
    // Run on scroll
    $(window).on('scroll', updateActiveSection)
    
    // Run once on page load
    updateActiveSection()
  }
})